import casify from './casify';

export function CamelToTitle(camelCase) {
  const outValue = camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
  return outValue.charAt(0).toUpperCase() + outValue.substr(1);
}

export const camelToTitle = casify(CamelToTitle);

export default camelToTitle;